const namespace = "LAYOUT_";

const CONSTANTS = {
  LAYOUT_PAGE_HEADING: `${namespace}PAGE_HEADING`,
  LAYOUT_SCROLL_TOGGLE: `${namespace}SCROLL_TOGGLE`,
  LAYOUT_PULL_DOWN_REFRESH: `${namespace}PULL_DOWN_REFRESH`,
  LAYOUT_PULL_DOWN_REFRESH_RELEASE: `${namespace}PULL_DOWN_REFRESH_RELEASE`,
  LAYOUT_SHOW_SUGGESTIONS: `${namespace}SHOW_SUGGESTIONS`,
  LAYOUT_USER_DETAILS_INFO: `${namespace}USER_DETAILS_INFO`,
  BUYNOW_DOUBT_BUDDY_MODAL: `${namespace}BUYNOW_DOUBT_BUDDY_MODALL`,

  // LAYOUT_SCROLL_TOGGLE: `${namespace}SCROLL_TOGGLE`,
  // LAYOUT_SCROLL_TOGGLE: `${namespace}SCROLL_TOGGLE`,
};

export default CONSTANTS;
